export enum ESearchGroupFormLabelsTypes {
  firearmSerialNumber = 'legalEntityDetails.firearm.accordion.serialNumber.column',
}

export enum ESearchUserFormLabelsTypes {
  email = 'users.email.label',
  firstName = 'users.firstName.label',
  lastName = 'users.lastName.label',
  phoneNumber = 'users.phoneNumber.label',
  statuses = 'users.status.label',
  rolesUniqueIds = 'users.role.label',
  displayUniqueId = 'users.displayUniqueId.label',
}

export enum ESearchAncillariesFormLabelsTypes {
  ancillaryUniqueId = 'legalEntityDetails.ancillaries.accordion.ancillary.column',
  ancillaryTypeUniqueId = 'legalEntityDetails.ancillaries.accordion.type.column',
  fireCycleId = 'legalEntityDetails.ancillaries.accordion.firecycleId.column',
  stateUniqueId = 'legalEntityDetails.ancillaries.accordion.state.column',
  marking = 'legalEntityDetails.ancillaries.accordion.marking.column',
}

export enum ESearchAncillaryGroupsFormLabelsTypes {
  ancillary = 'legalEntityDetails.ancillaries.accordion.ancillary.column',
}

export enum ESearchFirearmFormLabelsTypes {
  serialNumber = 'legalEntityDetails.firearm.accordion.serialNumber.column',
  marking = 'legalEntityDetails.firearm.accordion.marking.label',
  makeUniqueId = 'legalEntityDetails.firearm.accordion.make.column',
  stateUniqueId = 'legalEntityDetails.firearm.accordion.state.column',
}

export enum ESearchGroupFirearmFormLabelsTypes {
  serialNumber = 'groupDetails.firearmListSection.serialNumber.label',
  makeUniqueId = 'groupDetails.firearmListSection.make.label',
  modelUniqueId = 'groupDetails.firearmListSection.model.label',
  caliberUniqueId = 'groupDetails.firearmListSection.calibre.label',
}

export enum ESearchGroupAncillaryFormLabelsTypes {
  ancillaryType = 'ancillaries.searchForAncillary.ancillary.filter.label',
  ancillarySpecificTypeUniqueId = 'ancillaries.searchForAncillary.ancillaryType.filter.label',
  firearmType = 'ancillaries.searchForAncillary.firearmType.filter.label',
  serialNumber = 'ancillaries.searchForAncillary.serialNumber.filter.label',
  lotNumber = 'ancillaries.searchForAncillary.lotNumber.filter.label',
  batchNumber = 'ancillaries.searchForAncillary.batchNumber.filter.label',
  manufacturersUniqueIds = 'ancillaries.searchForAncillary.manufacturer.filter.label',
}

export enum ESearchFirearmsFormLabelsTypes {
  serialNumber = 'searchForLegalEntitysFirearm.serialNumber.label',
  marking = 'searchForLegalEntitysFirearm.markings.label',
  stateUniqueId = 'searchForLegalEntitysFirearm.state.label',
  makeUniqueId = 'searchForLegalEntitysFirearm.make.label',
  modelUniqueId = 'searchForLegalEntitysFirearm.model.label',
  legalityUniqueId = 'searchForLegalEntitysFirearm.legality.label',
  manufacturerUniqueId = 'searchForLegalEntitysFirearm.manufacturer.label',
  caliberUniqueId = 'searchForLegalEntitysFirearm.calibre.label',
}

export enum ESearchTransactionFormLabelsTypes {
  stateUniqueId = 'registeredFirearms.firearmsDetails.transactions.accordion.state.label',
  transactionDateFrom = 'registeredFirearms.firearmsDetails.transactions.accordion.transactionDateFrom.label',
  transactionDateTo = 'registeredFirearms.firearmsDetails.transactions.accordion.transactionDateTo.label',
}

export enum ESearchLicencesFormLabelsTypes {
  weaponLicenceNumber = 'legalEntityDetails.licenceTab.weaponLicenceNumber.column',
  statusUniqueId = 'legalEntityDetails.licenceTab.status.column',
}

export enum ESearchFormLabels {
  weaponLicenceNumber = 'licences.weaponLicenceNumber.label',
  weaponLicenceName = 'licences.licenceName.label',
  legalName = 'licences.legalName.label',
  legalTypeUniqueId = 'licences.legalType.label',
  statusesUniqueIds = 'licences.status.label',
  expiryDateFrom = 'licences.expiryDateFrom.label',
  expiryDateTo = 'licences.expiryDateTo.label',
  licenceAuthorityUniqueIds = 'licences.licencingAuthority.label',
}
